export default {
  stats: {
    title: "Estatísticas",
    tabs: {
      team: "Estatísticas da equipe",
      player: "Estatísticas do jogador",
    },
    empty: {
      unavailable: "Estatísticas indisponíveis no momento.",
    },
    filters: {
      titles: {
        qualifier: "Qualificador",
        type: "Tipo",
        position: "Posição",
      },
      plurals: {
        qualifier: "Qualificadores",
        type: "Tipos",
        position: "Posições",
      },
      options: {
        qualifier: {
          averageStats: "Por jogo",
          cumulativeStats: "Total",
        },
        type: {
          offensive: "Ofensivo",
          defensive: "Defensivo",
        },
      },
    },
  },
};
